import * as actionTypes from "./contactActionType";
import axios from 'axios';
import { checkError, apiTimeout } from './../error';
import { toast } from 'react-toastify';
const { REACT_APP_API_URL } = process.env;

export const contactCreate = (data) => {
    return (dispatch) => {
        dispatch(contactCreateInit());
        apiTimeout(axios.post(`${REACT_APP_API_URL}/contact/store`, data))
        .then((response) => {
            toast.success("We received your query. We will contact you for more information.", {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored"
            });
            dispatch(contactCreateSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(contactCreateFailure());
            checkError(error);
        })
    };
};

export const contactCreateInit = () => ({
    type: actionTypes.CONTACT_CREATE
});

export const contactCreateFailure = () => ({
    type: actionTypes.CONTACT_CREATE_FAILURE
});

export const contactCreateSuccess = data => ({
    type: actionTypes.CONTACT_CREATE_SUCCESS,
    payload: { data }
});
